import { message } from 'src/constantsMessage';
import axios from 'src/utils/axiosHelper';
import helperAxios from 'src/utils/helperAxios';
import { SET_ALERT } from './alertAction';
import {
  encode64Base,
  formDataToencode64Base
} from 'src/context/constantMethod';
import getProductType from 'src/components/ProductType';

const productType = getProductType();

export const GET_USERS = '@users/get-users';
export const GET_USERS_ERROR = '@users/get-users-error';
export const GET_USERS_EMPTY = '@users/get-users-empty';
export const GET_USER_DETAIL = '@users/get-users-detail';
export const GET_USER_DETAIL_ERROR = '@users/get-user-detail-error';
export const GET_USER_DETAIL_EMPTY = '@users/get-user-detail-empty';
export const CREATE_USER = '@users/create-users';
export const CREATE_USER_ERROR = '@users/create-users-error';
export const EDIT_USER = '@users/edit-users';
export const EDIT_USER_ERROR = '@users/edit-users-error';
export const MAIL_SEND = '@users/mail-send';
export const MAIL_SEND_ERROR = '@users/mail-send-error';
export const CREATE_EMPTY = '@users/createEmpty';
export const EDIT_EMPTY = '@users/editEmpty';
export const LOADER = '@users/loader';

export function getAllUsers(pageNo, pageSize, order, orderBy, search) {
  const params = {
    page: pageNo,
    size: pageSize,
    order: order,
    sortBy: orderBy,
    userSearch: search
  };
  const url = `/api/bsa/v2/user/all`;
  const request = helperAxios(url, 'get', null, params);

  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: GET_USERS,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: GET_USERS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error',
          redirect: `/${productType.toLowerCase()}/home`
        });
      });
  };
}

export function getAllUsersEmpty() {
  return dispatch => {
    dispatch({
      type: GET_USERS_EMPTY
    });
  };
}

export function getUserDetail(id) {
  const url = `/api/bsa/v2/user/${id}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    request
      .then(response => {
        dispatch({
          type: GET_USER_DETAIL,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: GET_USER_DETAIL_ERROR,
          payload: error.response && error.response.data
        });
      });
  };
}

export function getUserDetailEmpty() {
  return dispatch => {
    dispatch({
      type: GET_USER_DETAIL_EMPTY
    });
  };
}

export function createUser(values, isString) {
  const url = `/api/bsa/v2/user`;
  const bodyData =
    productType !== 'Precisa'
      ? {
        firstName: values.name,
        email: values.email,
        password: encode64Base(values.password, isString),
        rolesList: [values.role]
      }
      : {
        firstName: values.name,
        email: values.email,
        rolesList: [values.role]
      };
  const request = helperAxios(url, 'put', bodyData);
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: CREATE_USER,
          payload: response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: message.createSuccess,
          payload1: 'success'
        });
      })
      .catch(error => {
        dispatch({
          type: CREATE_USER_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function createEmpty() {
  return dispatch => {
    dispatch({
      type: CREATE_EMPTY
    });
  };
}

export function editUser(id, values, isString) {
  const url = `/api/bsa/v2/user/${id}`;
  const bodyData = productType !== 'Precisa' ? {
    id: id,
    firstName: values.name,
    email: values.email,
    password: encode64Base(values.password, isString),
    rolesList: [values.role],
    enabled: values.status === 'Active' ? true : false
  } : {
    id: id,
    firstName: values.name,
    email: values.email,
    rolesList: [values.role],
    enabled: values.status === 'Active' ? true : false
  };
  const request = helperAxios(url, 'post', bodyData);

  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: EDIT_USER,
          payload: response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: message.editSuccess,
          payload1: 'success'
        });
      })
      .catch(error => {
        dispatch({
          type: EDIT_USER_ERROR,
          payload: error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function editEmpty() {
  return dispatch => {
    dispatch({
      type: EDIT_EMPTY
    });
  };
}

export function resendMail(email) {
  const url = `/api/bsa/v2/user/resendUserEmail?email=${email}`;

  const request = helperAxios(url, 'get');

  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: MAIL_SEND,
          payload: response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: message.loginDetailsSent,
          payload1: 'success'
        });
      })
      .catch(error => {
        dispatch({
          type: MAIL_SEND_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}
